<template>

    <div>
        <header-page></header-page>
        <full-page :options="options" id="fullpage">
            <div class="section" id="section0">
                <div class="slide" id="coktailP1">
                </div>
            </div>
            <div class="TitleBottom"><a
                    @click="$vuetify.goTo('#welcome',{ duration:1000, offset:0, easing:'easeInOutCubic'})">
                <h1>
                    <v-icon :size="screenwidth" color="white">mdi-chevron-down</v-icon>
                    Cocktail &amp; apéritif dînatoire
                </h1>
            </a></div>
        </full-page>
        <div>
            <div class="backgroundGreen" id="welcome">
                <div class="media-row">
                    <div class="row backgroundGreen">
                        <div class="col-12 col-md-8 col-lg-8" style="background:#826c58;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h2 class="display-5 bottomH2">
                                            A vous de composer !
                                        </h2>
                                        <h3  style="font-size:35px;font-family: 'Nunito', sans-serif;font-weight: bold">
                                            Le <b>cocktail</b>, c’est la solution toute trouvée pour organiser des
                                            réceptions chaleureuses et conviviales en toute liberté.
                                        </h3>
                                        <p>
                                            Chaque invité picore selon ses envies, parmi un large choix de mets
                                            présentés sous forme de jolies petites <b>bouchées individuelles</b>. Ces
                                            portions faciles à manger sont idéales pour passer d’une conversation à
                                            l’autre, sans s’encombrer de couverts.
                                        </p>
                                        <p>
                                            Pour votre cocktail, vous pouvez opter pour des réductions salées ou
                                            sucrées, froides ou chaudes.
                                        </p>

                                        <p>Nos cocktails sont proposés avec ou sans prestation de service, selon vos
                                            besoins.</p>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-image: url('img/cocktail/cocktail-dinatoire.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h3 class="display-6 titleSpacer" style="background-color: #7d2c6fb3;">Notre offre cocktail</h3>
                                        <p>
                                        <div class="btns-action sr-up-td3 text-primary">
                                            <a href="pdf/tarif-traiteur-cocktail.pdf" target="_blank"
                                               class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                <span class="text">Découvrir le COCKTAIL DÉJEUNATOIRE </span>
                                            </a>
                                        </div>
                                        <div class="btns-action sr-up-td3 text-primary">
                                            <a href="pdf/traiteur-aperitif.pdf" target="_blank"
                                               class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                <span class="text">Découvrir l'offre APÉRITIF</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="media-row">
                <div class="row backgroundGreen">
                    <div class="col-12 col-md-4 col-lg-4" style="background:#645657;">
                        <div class="item media text-white alignLeft">
                            <div class="media-body align-top">
                                <div class="desc">
                                    <h3 class="display-6">
                                        Bien plus simple à organiser qu’un buffet ou un repas assis, le cocktail
                                        s’adapte à toutes les situations :
                                    </h3>
                                    <p class="pAlpha">
                                    <ul>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Apéritif déjeunatoire ou dînatoire
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Vin d’honneur précédant un repas de mariage
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Soirées informelles comme un anniversaire entre amis
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Arrivée des invités en ordre dispersé
                                        </li>
                                        <li>
                                            <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                            Espace ou temps limité, ne permettant pas d’asseoir les convives
                                        </li>
                                    </ul>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('img/cocktail/plateau-cocktail-traiteur.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="img/cocktail/plateau-cocktail-traiteur.jpg" alt="An image"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('img/cocktail/plateau-cocktail-traiteur.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                            <div class="media-body align-top">
                                <div class="desc">

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-color:#888853;">
                        <div class="item media text-white alignLeft">
                            <div class="media-body align-top">
                                <div class="desc">
                                    <p style="font-size:35px;font-family: 'Nunito', sans-serif;font-weight: bold">
                                        Nos cocktails sont proposés avec ou sans prestation de service, selon vos besoins.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="media-row">
                <div class="row backgroundGreen">
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('img/cocktail/sushis.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="img/cocktail/sushis.jpg" alt="Sushis"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('img/cocktail/sushis.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                            <div class="media-body align-top">
                                <div class="desc">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"  style="background:#502139;">
                        <div class="item media text-white alignLeft">
                            <div class="media-body align-top">
                                <div class="desc">
                                    <h3 class="display-6">Une équipe réactive</h3>
                                    <p>
                                        Vous avez très peu de temps pour organiser un cocktail ou un apéritif dînatoire ? Croustillance vous fournit un devis rapidement et s’adapte à chacune de vos contraintes (espaces/temps/budget…).
                                    </p><br><br>
                                    <h3 class="display-6">Plaisir des yeux et de la bouche</h3>
                                    <p>
                                        Bouchées, verrines, mini-sandwichs, cuillères : à vous de piocher vos préférés, visuellement vous serez toujours gagnant.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('img/cocktail/cocktail-tapas.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="img/cocktail/cocktail-tapas.jpg" alt="An image"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('img/cocktail/cocktail-tapas.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                            <div class="media-body align-top">
                                <div class="desc">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer-page> </footer-page>
    </div>


</template>

<script>
    import HeaderPage from './headerPage'
    import FooterPage from './footerPage'

    export default {
        name: 'app',
        components: {
            HeaderPage,
            FooterPage
        },
        data() {
            return {
                options: {
                    licenseKey: 'A32C7F42-F0FE4A04-AAB7E182-AB1F9C8B',
                    navigation: false,
                    scrollBar: true,
                    autoScrolling: false,
                    fitToSection: false
                }
            }
        },
        methods: {
            afterLoad() {
                console.log('After load')
            },
        },
        computed: {
            screenwidth() {
                if (screen.width > 400) {
                    return 70
                } else {
                    return 30
                }
            }
        },
    created() {
        document.getElementsByTagName('meta')["description"].content = " Le cocktail, c’est l'idéal pour des réceptions conviviales en toute liberté. Chaque invité fait son choix parmi de jolies petites portions individuelles.";
        document.title = " Cocktails pour vos réceptions privées";
    }
    }
</script>

<style>
    .TitleBottom {
        position: absolute;
        z-index: 1;
        bottom: 0px;
        display: inline-block;
        right: 0px;
        background-color: #95c01e;
        padding-right: 10px;
    }

    .TitleBottom h1 {
        padding: 10px;
        color: white;
        font-family: 'Nunito', sans-serif;
        font-weight: 600;
    }

    .iconTitle {
        font-size: 60px;
    }

    .Titreh1 {
        display: inline-block;
        padding: 10px;
        color: #2c6730;
        background-color: #ffffff70;
    }

    .Titreh2 {
        Display: inline-block;
        padding: 10px;
        color: #2c6730;
        background-color: #ffffff70;
    }

    #coktailP1 {
        background: url('/img/cocktail/cocktail-intro1.jpg') no-repeat center center;
        padding: 0 0 0 0;
        background-size: cover;
    }
</style>